"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const styles_1 = require("../styles");
const Divider = () => {
    return react_1.default.createElement(react_native_1.View, { style: styles.divider });
};
exports.default = Divider;
const styles = react_native_1.StyleSheet.create({
    divider: {
        width: '100%',
        marginVertical: styles_1.getSpacing(),
        borderBottomWidth: styles_1.getSpacing('border'),
        borderBottomColor: styles_1.Colors.midGray,
    },
});
